import { render, staticRenderFns } from "./TambahLaporanPenelitiKeamanan.vue?vue&type=template&id=73a1d370&scoped=true&"
import script from "./TambahLaporanPenelitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./TambahLaporanPenelitiKeamanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a1d370",
  null
  
)

export default component.exports